import * as React from 'react';
import { RequestState } from '../constants/request-state';
import { documentsService } from '../services/documents.service';
import { logger } from '../logging/logger';

export function useSecurityDocumentsExistFlag(identifier?: string, disabled: boolean = false) {
    const [state, setState] = React.useState({ isExist: false, requestState: RequestState.none });

    React.useEffect(() => {
        const request = async () => {
            if (disabled) return;

            try {
                const isExist: boolean = await documentsService.getSecurityDocumentsExistFlag(identifier);
                setState({ isExist, requestState: RequestState.success });
            } catch (e) {
                logger.exception(e as Error, 'Failed to request company documents exist flag');
                setState({ isExist: true, requestState: RequestState.failure });
            }
        }

        if (identifier) {
            setState({ isExist: false, requestState: RequestState.request });
            request();
        }
    }, [disabled, identifier]);

    const result: [requestState: RequestState, isDocumentsExist: boolean] = [state.requestState, state.isExist];

    return result;
}
